//Dev-harness settings for the /dev/home/ route (deploy/routes/web.php ->
//AppController::devHome). That route renders the normal home view with the
//intro skipped and window.devHome injected; when that global is present the
//members below drive the opening state (HomeController jumps straight to the
//configured department, config/webgl-home picks up webglType).
//
//THIS FILE IS MEANT TO BE EDITED LOCALLY during development — change
//department / webglType to whatever you are working on. Don't worry about it
//shipping: the /dev/home/ route 404s outside the local Laravel environment,
//so without window.devHome everything here is inert (`active` is false and
//nothing reads the other members).
import type { HomeWebGLType } from 'app/views/home/webgl/webgl.types';

//The department scenes the harness can open on ('home' = the rest position
//at progress 0; the others = their config/webgl-home sceneBands midpoint):
export type DevHomeDepartment = 'home' | 'screens' | 'spaces' | 'systems';

const validDepartments: Array<DevHomeDepartment> = ['home', 'screens', 'spaces', 'systems'];

export default {
	//Department the home view opens on when the harness is active. EDIT ME.
	department: 'screens' as DevHomeDepartment,

	//Home WebGL implementation the harness mounts (see config/webgl-home
	//homeType resolution order — a ?webgl= query still beats this). null =
	//leave webgl-home's normal resolution alone. EDIT ME.
	webglType: 'debug' as HomeWebGLType | null,

	//True only on the /dev/home/ route (window.devHome is Blade-injected
	//there and nowhere else) — every consumer must check this first:
	get active(): boolean {
		return !!window.devHome;
	},

	//The department to actually open on: a /dev/home/{department} URL segment
	//(Blade-injected as window.devHomeDepartment, already server-validated —
	//re-validated here anyway) overrides the locally-edited default above:
	get activeDepartment(): DevHomeDepartment {
		const urlDepartment = window.devHomeDepartment as DevHomeDepartment;
		return validDepartments.indexOf(urlDepartment) !== -1 ? urlDepartment : this.department;
	},

	//Benchmark knobs for the S1 GATE scaling sweep (docs/DESIGN-shaders-type.md
	//§9, harness qa/bench/shaders-scaling.mjs). Active ONLY on the /dev/home/
	//harness (`active` gates them), so production is untouched.

	//?sysCount=N overrides the systems particle count for EVERY home type:
	//HomeFieldConfig.systemsParticles reads it (systems is the last pool slice,
	//so the CPU SoA capacity/indexes grow with it), and shadersSystemsConfig.count
	//forwards that. null = leave the shipped 3650. This is the count the gate
	//sweeps past the CPU ceiling.
	get systemsCount(): number | null {
		if (!this.active) return null;
		const raw = new URLSearchParams(window.location.search).get('sysCount');
		if (!raw) return null;
		const n = parseInt(raw, 10);
		return Number.isFinite(n) && n > 0 ? n : null;
	},

	//?simSkip=1 makes the GPU systems field SKIP its compute pass and only draw
	//the N static quads — isolates FILL-RATE from COMPUTE (design §9 "name which
	//bit first"): if fps still rolls off with the sim skipped, the GPU ceiling is
	//fill-rate, not math. No-op for the CPU types.
	get simSkip(): boolean {
		return this.active && new URLSearchParams(window.location.search).get('simSkip') === '1';
	}
};
